import { render } from "./OtpInput.vue?vue&type=template&id=5943be88&scoped=true"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=5943be88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5943be88"]])

export default __exports__